import { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useAuthStorage } from '../../hooks/useAuthStorage';

import './ToggleButton.scss';

const ToggleButton = ({
  size,
  type,
  businessId,
  userId,
  channel,
  globalStatus,
  onToggleChange,
  isAssignedToLucci,
}) => {
  // Instagram (2) / Messenger (5) are keyed by contact_medium on the bot; pass the
  // channel so the back-end proxy hits the right endpoint.
  const channelParam = channel ? `&channel=${channel}` : '';
  const [isOn, setIsOn] = useState(true);
  const LUCCI_URL = '/lucci';
  const { getToken } = useAuthStorage();
  const token = getToken();
  const { t } = useTranslation('inbox');

  //! Fetch initial status when component mounts or when globalStatus changes
  useEffect(() => {
    // Verifica si es necesario ejecutar el useEffect
    if (!businessId || !token || (type === 'user' && !userId)) {
      return;
    }

    if (!globalStatus && type === 'user') return setIsOn(false); // Si el estado global es inactivo retorna estado inactivo para el usuario

    const fetchStatus = async () => {
      const url =
        type === 'global'
          ? `${LUCCI_URL}/status/globally?business_id=${businessId}`
          : `${LUCCI_URL}/status/byuser?business_id=${businessId}&user=${userId}${channelParam}`;

      try {
        const response = await axios.get(url);
        setIsOn(response.data.status);
      } catch (error) {
        console.error('Error fetching status:', error);
      }
    };

    fetchStatus(); // Ejecuta la funcion para setear el estado global o por usuario en el backend

    if (type === 'global') {
      setIsOn(globalStatus); // Ajusta el estado en el front
    }
  }, [businessId, userId, type, globalStatus]);

  //! Function that handles the toggle status change event
  const handleToggle = async () => {
    if (!token) {
      return;
    }

    // Change the local status of the toggle
    const newStatus = !isOn;
    setIsOn(newStatus);

    const url =
      type === 'global'
        ? `${LUCCI_URL}/set/globally?business_id=${businessId}&status=${newStatus}`
        : `${LUCCI_URL}/set/byuser?business_id=${businessId}&user=${userId}&status=${newStatus}${channelParam}`;

    try {
      //:: HTTP GET request to change toggle status in backend
      await axios.get(url);

      // Notify parent component of the change if it's a global toggle
      if (type === 'global' && onToggleChange) {
        onToggleChange(newStatus);
      }
    } catch (error) {
      setIsOn(!newStatus);
      console.error('Error updating status:', error);
    }
  };

  const height = size === 'small' ? '2.4rem' : '34px';

  return (
    <div
      className={`toggle-button ${isOn ? 'on' : 'off'}`}
      onClick={
        /* (isAssignedToLucci && type === 'user') || */
        type === 'user' && !globalStatus ? null : handleToggle
      } // Si el estado global es inactivo y es de tipo user no tendra ningun efecto cambiar el estado por usuario
      style={{
        height,
        backgroundColor:
          /* (isAssignedToLucci && type === 'user') || */
          !globalStatus && type === 'user' ? '#efefef' : '#fff',
        filter:
          /* (isAssignedToLucci && type === 'user') || */
          !globalStatus && type === 'user' ? 'opacity(.5)' : 'opacity(1)',
      }}
      title={t('toggle.turn_global_on')}
    >
      <div className="toggle-button__switch">
        <div className="toggle-button__circle"></div>
      </div>
      <span className="toggle-button__label">Lucci</span>
    </div>
  );
};

export default ToggleButton;
